import React, { useState, useContext } from 'react';
import { TableHeader } from './helper/ui-helper';
import AppContext from './AppContext';
import PokedexMenuSprite from './PokedexMenuSprite';

function PokedexTableRow({
  speciesId,
  index,
  tableHeaders,
  includeSprites,
}: {
  speciesId: string,
  index: number,
  tableHeaders: TableHeader[],
  includeSprites: boolean,
}) {
  const {
    dex: pokedex,
    setClickedSpeciesId: rowOnClick,
    spritePosition,
  } = useContext(AppContext);
  const [hoveredRow, setHoveredRow] = useState<boolean | null>(null);
  const stats = pokedex[speciesId];
  const trClassName = 'table-row border-b border-gray-200 cursor-pointer';
  const tdClassName = 'whitespace-nowrap text-gray-600 text-xs px-1 py-1.5';
  let trBackground = 'bg-gray-50';
  if (hoveredRow) trBackground = 'bg-red-100';
  else if (index % 2 === 0) trBackground = '';
  return (
    <tr
      className={`${trClassName} ${trBackground}`}
      onClick={() => rowOnClick(speciesId)}
      onMouseEnter={() => setHoveredRow(true)}
      onMouseLeave={() => setHoveredRow(false)}
    >
      {
        includeSprites
          ? <td><PokedexMenuSprite currentSpritePosition={spritePosition[speciesId]} /></td> // eslint-disable-line
          : null
      }
      {tableHeaders.map((header: TableHeader) => {
        if (header.render !== undefined) {
          return header.render(stats);
        }
        return (
          <td key={`trtd-${speciesId}-${header.name}}`} className={tdClassName}>
            {header.value(stats)}
          </td>
        );
      })}
    </tr>
  );
}

export default PokedexTableRow;
